import { useSelector, useDispatch } from "react-redux";
import useFetch from "../../utils/useFetch";
import { setDetail } from "./store";

const useAccounts = () => {
  const dispatch = useDispatch();
  const data = useSelector((state) => state.accounts);
  const { get, post } = useFetch();

  const endpoint = "accounts";

  const fetchAccount = async (id) => {
    const acc = await get({ endpoint: `${endpoint}/${id}`, isPrivate: true });
    dispatch(setDetail(acc));
  };

  const createAccount = async (data) => {
    return await post({
      endpoint,
      body: data,
    });
  };

  // const fetchAnalytics = async (restaurant) => {
  //   const response = await get({
  //     endpoint: `${endpoint}/statistics`,
  //     params: { restaurant },
  //     isPrivate: true,
  //   });
  //   response && dispatch(setAnalytics(response));
  // };

  const updateCompanyInfo = async (data) => {
    return await post({
      endpoint: `${endpoint}/update-company-info`,
      body: data,
    });
  };

  const setPaymentMethod = async (data) => {
    return await post({
      endpoint: `${endpoint}/set-payment-method`,
      body: data,
    });
  };

  const createSetupIntent = async () => {
    return await post({
      endpoint: `${endpoint}/create-setup-intent`,
    });
  };

  const createKitPayment = async (data) => {
    return await post({
      endpoint: `${endpoint}/subscribe-with-kit`,
      body: data,
    });
  };

  const confirmSubscription = async (data) => {
    return await post({
      endpoint: `${endpoint}/confirm-subscription`,
      body: data,
    });
  };

  const getStripePortalUrl = async () => {
    return await get({
      endpoint: `${endpoint}/stripe-portal-url`,
      isPrivate: true,
    });
  };

  return {
    account: data.detail,
    fetchAccount,
    createAccount,
    updateCompanyInfo,
    setPaymentMethod,
    createSetupIntent,
    getStripePortalUrl,
    createKitPayment,
    confirmSubscription,
  };
};

export default useAccounts;
